import firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig = {
	apiKey: "AIzaSyAHajslTljQ1mNFUWM3E2fiJYazNvl97gg",
	authDomain: "mafia-50c3a.firebaseapp.com",
	databaseURL: "https://mafia-50c3a.firebaseio.com",
	projectId: "mafia-50c3a",
	storageBucket: "mafia-50c3a.appspot.com",
	messagingSenderId: "1016875144186",
	appId: "1:1016875144186:web:f8f53da6edcaaaca"
}

firebase.initializeApp(firebaseConfig)

const firestore = firebase.firestore()

function getRoomDataDocument() {
	return firestore.collection('Room').doc(process.env.VUE_APP_FIREBASE_ROOM_ID)
}

async function getRoomData() {
	let doc = await getRoomDataDocument().get()

	return doc.exists ? doc.data() : null
}

async function updateRoomData(roomData) {
	await getRoomDataDocument().update(roomData)
}

function getRoomPlayersCollection() {
	return getRoomDataDocument().collection('Players')
}

function getRoomVotesCollection() {
	return getRoomDataDocument().collection('Votes')
}

async function getRoomPlayersDocuments() {
	let snapshot = await getRoomPlayersCollection().get()

	return snapshot.docs
}

async function getRoomVotesDocuments() {
	let snapshot = await getRoomVotesCollection().get()

	return snapshot.docs
}

async function getRoomPlayerDocument(username) {
	let snapshot = await getRoomPlayersCollection().where('username', '==', username).get()

	if (snapshot.docs.length) {
		return snapshot.docs[0]
	}
}

async function getRoomVoteDocument(voter) {
	let snapshot = await getRoomVotesCollection().where('voter', '==', voter).get()

	if (snapshot.docs.length) {
		return snapshot.docs[0]
	}
}

async function emptyCollection(collection) {
	let snapshot = await collection.get()

	await Promise.all(snapshot.docs.map(doc => doc.ref.delete()))
}

async function resetRoomData() {
	await updateRoomData({
		isStarted: false,
		hasMafiaReportedSuccess: false,
		didMafiaSucceed: false,
		didVillageSucceed: false,
		isComplete: false
	})

	await emptyCollection(getRoomPlayersCollection())
	await emptyCollection(getRoomVotesCollection())
}

async function addPlayerToRoom({ username, isLeader }) {
	let doc = await getRoomPlayerDocument(username)

	if (!doc) {
		await getRoomPlayersCollection().add({
			username,
			isLeader,
			role: '',
			points: 0
		})
	}
}

async function removePlayerFromRoom(username) {
	let doc = await getRoomPlayerDocument(username)
	if (doc) {
		let isLeader = doc.data().isLeader

		await doc.ref.delete()

		if (isLeader) {
			// Find a new leader
			let playersDocuments = await getRoomPlayersDocuments()

			if (playersDocuments.length > 0) {
				await playersDocuments[0].ref.update({
					isLeader: true
				})
			}
		}
	}
}

async function generateRoles() {
	let playersDocuments = await getRoomPlayersDocuments()
	let mafiaIndex = Math.floor(Math.random() * new Date()) % playersDocuments.length

	await Promise.all(playersDocuments.map((doc, index) => {
		return doc.ref.update({
			role: (mafiaIndex == index) ? 'mafia' : 'villager'
		})
	}))
	
	await updateRoomData({ isStarted: true })
}

async function handleVote(voter, target) {
	let voterDocument = await getRoomPlayerDocument(voter)
	let targetDocument = await getRoomPlayerDocument(target)

	if (!voterDocument || voterDocument.data().role != 'villager' || !targetDocument) {
		return
	}

	let voteDocument = await getRoomVoteDocument(voter)

	if (voteDocument) {
		if (voteDocument.data().target == target) {
			await voteDocument.ref.delete()
		} else {
			await voteDocument.ref.update({ target })
		}
	} else {
		await getRoomVotesCollection().add({
			voter,
			target
		})
	}

	await checkRoomComplete()
}

async function setMafiaSuccess(username, isSuccessful) {
	let playerDocument = await getRoomPlayerDocument(username)

	if (!playerDocument || playerDocument.data().role != 'mafia') {
		return
	}

	let roomData = await getRoomData()

	roomData.didMafiaSucceed = isSuccessful
	roomData.hasMafiaReportedSuccess = true

	await updateRoomData({
		didMafiaSucceed: roomData.didMafiaSucceed,
		hasMafiaReportedSuccess: roomData.hasMafiaReportedSuccess
	})

	await checkRoomComplete(roomData)
}

async function checkRoomComplete(roomData) {
	if (!roomData) {
		roomData = await getRoomData()
	}

	let votesDocuments = await getRoomVotesDocuments()
	let playersDocuments = await getRoomPlayersDocuments()

	let votes = votesDocuments.map(doc => doc.data())
	let players = playersDocuments.map(doc => doc.data())

	let numVillagers = players.reduce((sum, player) => sum + (player.role == 'villager' ? 1 : 0), 0)

	if (votes.length == numVillagers && roomData.hasMafiaReportedSuccess) {
		let mafiaIndex = players.findIndex(player => player.role == 'mafia')
		let mafia = players[mafiaIndex]
		let mafiaPoints = roomData.didMafiaSucceed ? 1 : 0
		let correctVoters = []
		let numWrongVillagers = 0

		votes.forEach(vote => {
			let voterIndex = players.findIndex(player => player.username == vote.voter)

			if (vote.target == mafia.username) {
				correctVoters.push(voterIndex)
			} else {
				numWrongVillagers++
			}
		})

		let correctVoteValue = (correctVoters.length > numWrongVillagers) ? 2 : 1

		correctVoters.forEach(voterIndex => {
			let voter = players[voterIndex]

			voter.points += correctVoteValue

			playersDocuments[voterIndex].ref.update({ points: voter.points })
		})

		if (roomData.didMafiaSucceed && numWrongVillagers >= correctVoters.length) {
			mafiaPoints += numWrongVillagers
		}

		if (mafiaPoints > 0) {
			mafia.points += mafiaPoints

			playersDocuments[mafiaIndex].ref.update({ points: mafia.points })
		}

		await updateRoomData({
			didVillageSucceed: !roomData.didMafiaSucceed || correctVoters.length > numWrongVillagers,
			isComplete: true
		})
	}
}

async function setRoomToPlayAgain() {
	await updateRoomData({
		isStarted: false,
		hasMafiaReportedSuccess: false,
		didMafiaSucceed: false,
		didVillageSucceed: false,
		isComplete: false
	})

	let playerDocuments = await getRoomPlayersDocuments()

	await Promise.all(playerDocuments.map(doc => doc.ref.update({ role: '' })))

	await emptyCollection(getRoomVotesCollection())
}

export default {
	getRoomDataDocument,
	getRoomPlayersCollection,
	getRoomVotesCollection,
	resetRoomData,
	addPlayerToRoom,
	removePlayerFromRoom,
	generateRoles,
	handleVote,
	setMafiaSuccess,
	setRoomToPlayAgain,
}
